import React, { useEffect } from 'react';

import styles from './PrivacyPolicyContent.module.scss';

const PrivacyPolicyContent: React.FC = () => {
  useEffect(() => {
    let js = document.getElementsByTagName('script')[0];
    const tjs = document.getElementsByTagName('script')[0];
    // if (document.getElementById('termly-jssdk')) return;
    js = document.createElement('script');
    js.id = 'termly-jssdk';
    js.src = 'https://app.termly.io/embed-policy.min.js';
    tjs?.parentNode?.insertBefore(js, tjs);
  }, []);
  return (
    <main className={styles.root}>
      <div className={styles.container}>
        <div
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          name="termly-embed"
          data-id="e55e454d-dc79-41c3-a7fc-eb12015faaa4"
          data-type="iframe"
        />
      </div>
    </main>
  );
};

export default PrivacyPolicyContent;
